import { createReducer, on } from '@ngrx/store';
import { initialTipoContratoState } from './tipo-contrato.state';
import * as TipoContratoActions from './tipo-contrato.actions';

export const tipoContratoReducer = createReducer(
  initialTipoContratoState,

  // Load Tipos Contrato
  on(TipoContratoActions.loadTiposContrato, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(TipoContratoActions.loadTiposContratoSuccess, (state, { tiposContrato }) => ({
    ...state,
    tiposContrato,
    loading: false,
    error: null
  })),

  on(TipoContratoActions.loadTiposContratoFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Create Tipo Contrato
  on(TipoContratoActions.createTipoContrato, state => ({
    ...state,
    creating: true,
    error: null
  })),

  on(TipoContratoActions.createTipoContratoSuccess, (state, { tipoContrato }) => ({
    ...state,
    tiposContrato: [...state.tiposContrato, tipoContrato],
    creating: false,
    error: null
  })),

  on(TipoContratoActions.createTipoContratoFailure, (state, { error }) => ({
    ...state,
    creating: false,
    error
  })),

  // Update Tipo Contrato
  on(TipoContratoActions.updateTipoContrato, state => ({
    ...state,
    updating: true,
    error: null
  })),

  on(TipoContratoActions.updateTipoContratoSuccess, (state, { tipoContrato }) => ({
    ...state,
    tiposContrato: state.tiposContrato.map(tc =>
      tc.tipoContratoId === tipoContrato.tipoContratoId ? tipoContrato : tc
    ),
    selectedTipoContrato:
      state.selectedTipoContrato?.tipoContratoId === tipoContrato.tipoContratoId
        ? tipoContrato
        : state.selectedTipoContrato,
    updating: false,
    error: null
  })),

  on(TipoContratoActions.updateTipoContratoFailure, (state, { error }) => ({
    ...state,
    updating: false,
    error
  })),

  // Delete Tipo Contrato
  on(TipoContratoActions.deleteTipoContrato, state => ({
    ...state,
    deleting: true,
    error: null
  })),

  on(TipoContratoActions.deleteTipoContratoSuccess, (state, { id }) => ({
    ...state,
    tiposContrato: state.tiposContrato.filter(tc => tc.tipoContratoId !== id),
    selectedTipoContrato:
      state.selectedTipoContrato?.tipoContratoId === id ? null : state.selectedTipoContrato,
    deleting: false,
    error: null
  })),

  on(TipoContratoActions.deleteTipoContratoFailure, (state, { error }) => ({
    ...state,
    deleting: false,
    error
  })),

  // Search Tipos Contrato
  on(TipoContratoActions.searchTiposContrato, (state, { query }) => ({
    ...state,
    searchQuery: query,
    searchResults: []
  })),

  on(TipoContratoActions.searchTiposContratoSuccess, (state, { results }) => ({
    ...state,
    searchResults: results
  })),

  on(TipoContratoActions.clearTipoContratoSearch, state => ({
    ...state,
    searchResults: [],
    searchQuery: ''
  })),

  // Select Tipo Contrato
  on(TipoContratoActions.selectTipoContrato, (state, { tipoContrato }) => ({
    ...state,
    selectedTipoContrato: tipoContrato
  })),

  // Clear Error
  on(TipoContratoActions.clearTipoContratoError, state => ({
    ...state,
    error: null
  }))
);
